<template>
  <section class="hero-stack wf-section">
    <div class="container-7">
      <div class="hero-wrapper-two">
        <h1 class="backgrounder-heading">
            Backgrounder to the case of Dr. Aafia
        </h1>
        <h2 class="backgrounder-subheading">
          The most Innocent & Tragic Victim of Post-9/11 Torture
        </h2>
        <div class="newscontent backgrounder-content">
          <div v-html="highlightText(contentText, $store.state.searchQuery)">
          </div>
        </div>
        <div class="backgrounder-images">
          <img src="images/Picture1.png" alt="Dr. Aafia Siddiqui" class="backgrounder-image" />
          <img src="images/Picture2.png" alt="Dr. Aafia Siddiqui" class="backgrounder-image" />
        </div>
        <div class="newscontent backgrounder-content">
          <div v-html="highlightText(additionalContent, $store.state.searchQuery)">
          </div>
        </div>
        <div class="backgrounder-images">
          <img src="images/Picture4.png" alt="Agent in Ghazni" class="backgrounder-image" />
        </div>
        <div class="newscontent backgrounder-content">
          <div v-html="highlightText(ghazniContent, $store.state.searchQuery)">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "BackgrounderCase",
  data() {
    return {
      contentText: `Dr. Aafia Siddiqui (born 1972; BOP #90279-054) is perhaps the most tragic, innocent victim of the
            post-9/11 'War on Terror.' She is being held under a sentence of 86 years for allegedly attempting to
            murder two soldiers in Ghazni, Afghanistan, a patently false allegation (she was the only person shot).
            She is not eligible for release until she is well over 100 years old: if nothing changes, she will die in
            prison. There is powerful evidence that she is innocent of the allegations against her; regardless, she is
            profoundly traumatized by the torture she was subjected to in Bagram (2003-08) and by the unparalleled
            abuse of her three children; and she has faced endless physical, mental and sexual abuse in the infamous
            Texas prison where she is held, FMC Carswell.
            <br /><br />
            <strong>1. Aafia suffered at the hands of her abusive husband, who tried to blame her for his own
            extremism post-9/11</strong>
            <br /><br />
            Aafia was born in Pakistan. She went to the US as a teenager and was a stellar student, studying at MIT
            before receiving a PhD in education from Brandeis. She was married (by telephone) to Amjad Khan, who
            unfortunately turned out to be physically and emotionally abusive to her and the children. Amjad is also a
            <span class="highlight-text">big part of why she is locked up, as he became increasingly extreme after 9/11 and then, when the
            FBI were looking into him, he tried to pin his own extremism on her in the course of a bitter divorce.</span>
            Aafia initiated the divorce on the death-bed instruction of her elderly father, who died shortly after Amjad
            assaulted him during an argument, causing a fatal heart attack.
            <br /><br />
            Most telling of all concerning Amjad, when she and the three children were abducted, he raised not a
            finger to find them. Indeed, rather than try to locate his 4-year old daughter Maryam, he remarried, had
            another daughter, and called her … Maryam.
            <br /><br />
            <strong>2. Aafia and her Children are Abducted in Karachi in March 2003</strong>
            <br /><br />
            Aafia was abducted from the streets of Karachi, Pakistan (on March 30, 2003), by Pakistani officers
            working in league with the CIA. <span class="highlight-text">She appears to have fallen victim to the systematic sale of suspects to
            the US by the Pervez Musharraf government, detailed in his autobiography In the Line of Fire,
            where, on page 237, he boasts about selling 369 people for bounties. She was sold for a $55,000
            bounty.</span>
            <br /><br />
            Her U.S. lawyer has now managed to unpack what happened and why. Due to the activities of her
            husband, Aafia was herself a "person of interest" in 2002. The CIA, however, had almost every fact about
            her wrong. Getting false statements from KSM (Khalid Sheikh Mohammed) by waterboarding and
            torturing him, making him take names of 9 people.
            <br /><br />
            Just nine days later, she was abducted with her children. KSM had made up stories concerning all of them
            – eight have now been exonerated, and Aafia is the only person left in prison. We have now developed the
            evidence that proves Aafia's innocence as well.
            <br /><br />
            Some of Aafia's traumas are indisputable. When she was abducted, she had her three children
            with her – Suleman (below) was an infant, while Maryam was aged 4 and Ahmad was aged 6
            (below).`,
      additionalContent: `She was going to the Karachi airport for a flight to Islamabad to take up an education job. Ahmad
            was arguing passionately to go by train (he was a fan of the children's book Thomas the Tank
            Engine). The vehicle was surrounded, and the children were dragged from the taxi. Ahmad and
            Maryam were placed in one car, and Ahmad watched through the rear window as his mother was
            hauled out of the other car. According to Ahmad, the Pakistani and US agents carrying out this
            operation apparently dropped Suleman on his head, perhaps causing his death, but this has never
            been confirmed. <span class="highlight-text">To this day, Aafia does not know if Suleman is alive (and 23 years old) or
            dead. </span>
            <br /><br />
            Ahmad and Maryam are both dual US-Pakistani nationals, having been born in the US when
            Aafia was doing her doctorate. After her abduction, Maryam was taken to Kabul, where she was
            involuntarily 'fostered' into an American military family called Josh and Natalie. She remained
            with them for 7 years, told that her name was now Fatima. Apparently, this was done under the
            theory that she would be better off as an American Christian child than a Pakistani Muslim child.
            Ahmad was likewise taken by the US to Kabul, where he was held in a juvenile prison, and told
            his name henceforth was Ihsan Ali. He remained there for five years.
            <br /><br />
            While the CIA had previously denied having them in custody, this is now proven beyond doubt.
            Both would still be there were they not tracked down by their aunt, Dr. Fowzia Siddiqui,
            Harvard-trained and a former Johns Hopkins neurologist and Director of their Epilepsy Program.
            She worked with the ICRC to find Ahmad, and he was finally located in a Kabul prison.
            Threatened, he denied knowing Aafia or Fowzia when shown their pictures, but he plaintively
            asked to keep the photographs. Fowzia then insisted on a phone call with the child, and though he
            had again been threatened, when she came on the line with her distinctive voice, he
            spontaneously said 'Adda!' (a childish name he had for her), an even more convincing
            identification of him than DNA.
            <br /><br />
            Months went by before Fowzia was able to meet with then-President Hamid Karzai in Islamabad.
            He was touched by her story and ordered his intelligence people to search for Maryam. They
            apparently found her, and she was later dropped in Karachi with a sign around her neck listing
            Fowzia's address. This has recently been confirmed by Karzai himself.
            <br /><br />
            <strong>3. Torture and abuse of Aafia in Bagram and the Women's Prison (2003-08)</strong>
            <br /><br />
            We can now prove what happened to Aafia when she was "disappeared" for five years. We have
            (surreptitiously) recorded one of the original team members who abducted her, boasting about his role in
            detail. <span class="highlight-text">A senior officer in the ISI (the Pakistan intelligence agency) has detailed how she was
            abducted and turned over to "The Friends" (the CIA). A former US intelligence officer has
            described the false intelligence that led the CIA to think Aafia was the only woman in the Al Qaeda
            hierarchy.</span>
            <br /><br />
            Towards the start of her torment, she was in Bagram Air Force Base, in US custody, the only woman
            known to have been the object of the US 'Enhanced Interrogation' program. A series of witnesses have
            given sworn statements describing what happened to her starting in 2003. She was first held in the Bagram
            ISO unit, and then in the Bagram underground black site called the Discotheque (due to the endless loud
            music played at the prisoners to drive them insane). She was later moved to another black site reserved for
            women, where she was raped repeatedly.
            <br /><br />
            She reports undergoing horrific torture, forced to watch as children, purportedly (but not actually) her
            own, were tortured in front of her. She knew nothing about terrorism, but she was forced to make false
            statements about weapons and plots.
            <br /><br />
            The original reason she was suspected of terrorism was, like several tragedies in the wake of the horror of
            9/11, based on dreadful intelligence. It has recently been revealed that in 2002 she was thought to be a
            potential 'dirty bomber' who was going to be used by al Qaeda in the US because of her supposed PhD at
            MIT (it was from Brandeis) – which was thought to have been in Physics (it was in education). The details
            of all of this will inevitably be revealed in US proceedings.
            <br /><br />
            <strong>4. Aafia goes to Ghazni</strong>
            <br /><br />
            In Bagram, Aafia was forced to make false statements about Weapons of Mass Destruction. Eventually, as
            with so many War on Terror detainees, it became clear to the CIA that she was not a prisoner of any value.
            In the meantime, ironically, Dr. Fowzia had spearheaded a huge campaign to locate her sister, niece and
            nephews, including a million-person march in Karachi. <span class="highlight-text">This created a dilemma for her abductors, as
            her return to Pakistan would create massive publicity. What is euphemistically called a "Disposal
            Operation" was confected by (an intelligence agency) to ensure that she did not make it back home.</span>
            <br /><br />
            In 2008, she was told that she could be released from Bagram, and have her son Ahmad and daughter
            Maryam back, but when she went to Pakistan, she was to say she had been there all along. On July 16th,
            she was dumped out of CIA custody with a little money and given a Pakistani boy. She was told that if she
            went to a city called Ghazni, 150 km southwest of Kabul, she could have her daughter back. The boy,
            'Ihsan Ali' (actually Ahmad), had been threatened with death if he admitted his real identity, and he did
            not admit it even to his mother. She was so traumatised that she was not sure it was him. Even though it
            was the heat of summer in July 2008, 'Ihsan Ali' was wearing a jacket with four large pockets on the
            front, each with a large bit of fruit in it. This was intended to make him look like a suicide bomber. Two
            days before, the Afghan National Police (ANP) had received an anonymous call in Ghazni warning that a
            suicide bomber planned to attack the Jihad mosque.
            <br /><br />
            Aafia and "Ihsan Ali" took a bus from Bagram via Kabul to Ghazni, arriving midday on July 17,
            2008. With them in the bus was an Urdu-speaking agent with a bag containing evidence against
            Aafia that he was going to plant on her when she was killed. (A photograph of the agent who
            actually spoke with Aafia in Ghazni has recently been obtained, below.)`,
      ghazniContent: `Aafia went to the wrong mosque - the Khalid Bin Walid Mosque – and sat with the boy,
            expecting to be given Maryam so they could go to Pakistan. She waited there for over seven
            hours from midday until after dark. Recently, half a dozen witnesses who saw her there and saw
            what happened have come forward. Nobody could understand her, though, as they all spoke
            Farsi, and she spoke Urdu.
            <br /><br />
            The key person was Mohammed Ajwal Mohammedi, who was a tailor with a shop directly across
            the street from the Khalid Bin Walid Mosque. Mohammedi had done some work in Pakistan and
            spoke Urdu. He was able to learn why she was there and advised her to leave and stay with his
            aunt for the night. She would not go, saying she expected her daughter any moment.
            Mohammedi was nevertheless on hand to thwart the plan to kill Aafia. 40 ANP soldiers showed
            up with their AK-47S and would have simply shot her and the boy, but Mohammedi stood in the
            way and saved her life.
            <br /><br />
            She was then taken to the ANP HQ, where they determined she had committed no crime.
            <br /><br />
            <strong>The Shooting in Ghazni</strong>
            <br /><br />
            The next morning (July 18th, 2008), the American soldiers showed up at the ANP HQ demanding
            to interrogate her. The Chief of Police refused twice, but they bribed him, and were allowed to go
            upstairs to the room where she was being held. She was sleeping on a bed behind a curtain that
            bisected the room.
            <br /><br />
            Aafia was charged with attempted murder of a federal official. According to the prosecution,
            some U.S. personnel came into the room to meet with their Afghan counterparts. The
            prosecution's case was that a US soldier put his M4 rifle down on the floor, and she reached
            under the curtain, grabbed it, and tried to shoot the Americans in the room, letting off at least two
            rounds from the M4.
            <br /><br />
            She denies this. She says she was behind the curtain, heard American voices, thought they were
            going to take her back to Bagram for more torture, and peeked around the curtain. She says a
            soldier shouted, 'She's on the loose!' and then shot her.
            <br /><br />
            The physical evidence strongly supports Aafia's version of events:
            <br /><br />
            <ul style="list-style-type: none; padding-left: 0;">
              <li style="margin-bottom: 10px;">● No M4 projectiles or shell casings were found at the scene, though there were casings
            and bullets from the soldier's 9mm.</li>
              <li style="margin-bottom: 10px;">● While the prosecution told the jury there were two bullet holes in the wall, no projectiles
            were recovered from there, and we now have a video from earlier that day that reveals
            that the holes were already there before the incident.</li>
              <li style="margin-bottom: 10px;">● Aafia's fingerprints were not found on the M4.</li>
              <li style="margin-bottom: 10px;">● There was no evidence of Gun Shot Residue (GSR) on Aafia, her clothes or the curtain.</li>
              <li style="margin-bottom: 10px;">● There was no evidence that the M4 had fired a shot.</li>
              <li style="margin-bottom: 10px;">● Like most of us, she had no idea how to take the safety catch off an M4</li>
            </ul>
            <br /><br />
            In other words, there was no physical evidence at all to substantiate the prosecution's theory.
            <br /><br />
            <span class="highlight-text">Regardless of what the truth is about the allegations against her, she was the only person
            who got shot and nearly killed. Since we now know that she was the victim of a long-term
            kidnapping (by the CIA), the law should have required the jury to be instructed that she
            had the right to use deadly force anyway to escape from the ongoing felony.</span>
            <br /><br />
            <strong>Aafia Siddiqui's trial in the US</strong>
            <br /><br />
            She was tried in the Southern District of New York before Judge Berman in 2010. The SDNY is
            just 0.9 miles from "Ground Zero" (the site of the World Trade Center), and has a conviction rate
            over 99%. The witnesses were essentially all those brought by the US from Afghanistan to New
            York, with none telling her side of the story. The prosecution was permitted to tell the Court that
            she was 'in hiding' from the US for 5 years (2003-08) when actually she was being held and
            abused by the US. In 2009, the defence lawyers were not able to do the investigation in
            Afghanistan, which is now possible, since there was a war going on.             The lawyers were paid $2
            million by Pakistan and had an obvious conflict of interest – they could not bite the hand that fed
            them by showing Pakistan's complicity in her original abduction. They did not investigate her
            story and presented no evidence about her kidnapping.
            <br /><br />
            <span class="highlight-text">She was convicted and sentenced to the second-longest term of years imposed on someone in
            federal court for attempted murder in the past 41 years.</span> The judge knew nothing either of the
            years of her abduction and torture, or the abduction and abuse of two of her kids, and perhaps the
            murder of the third.
            <br /><br />
            <strong>Aafia's Mistreatment now in FMC Carswell, Fort Worth, Texas (2010-present)</strong>
            <br /><br />
            The prison where she is being held (FMC Carswell, in Fort Worth, Texas) is sadly notorious for
            abuse of prisoners, with thirteen employees criminally convicted of sexual assault in recent years
            (including on Christian chaplain). <span class="highlight-text">Aafia alleges that she has been raped by officers and
            sexually assaulted by officers and fellow prisoners alike. She is profoundly traumatised by
            22 years of detention and mistreatment.</span> Furthermore, because none of the mental health staff
            were told of her torture, they have misinterpreted her trauma as oppositional defiance. She had all
            her lower teeth knocked out by the CIA in Bagram.
            <br /><br />
            <strong>Justice for Aafia</strong>
            <br /><br />
            Her case is a cause célèbre in the Muslim world, the source of much friction between the US and
            their allies.
            <br /><br />
            Her American lawyer, Clive Stafford Smith, who has devoted over 4,000 hours pro bono (without
            asking a fee) to the investigation, has now served the prosecutors a 349 page application to have
            her conviction thrown out, with 947 pages of exhibits proving her case. Clive has also served
            what is called a Motion for Compassionate Release, which simply calls for her immediate
            liberation.
            <br /><br />
            Recently, Clive Smith went to New York and had a positive meeting with U.S attorneys.
            <br /><br />
            <strong>What can you do?</strong>
            <br /><br />
            There are many actions anyone can take:
            <br /><br />
            <ul style="list-style-type: none; padding-left: 0;">
              <li style="margin-bottom: 15px;">● Donations are welcome to fund the investigation and create a plan for her release and
            treatment. <a href="https://www.muslimgiving.org/aafia" target="_blank" style="color: #0066cc; text-decoration: underline;">https://www.muslimgiving.org/aafia</a></li>
              <li style="margin-bottom: 15px;">● Write to Aafia by email (<a href="mailto:letters4aafia@gmail.com" style="color: #0066cc; text-decoration: underline;">letters4aafia@gmail.com</a>)</li>
              <li style="margin-bottom: 15px;">● Medical professionals can sign onto an amicus brief (a legal pleading as a "friend of
            the court") challenging the denial of medical care to her in prison/
            <a href="https://www.aafiamovement.com/support-medical-care" target="_blank" style="color: #0066cc; text-decoration: underline;">https://www.aafiamovement.com/support-medical-care</a></li>
              <li style="margin-bottom: 15px;">● Religious scholars can sign onto an amicus brief challenging the denial of religious
            solace to her (Imam Omar Suleiman, who lives near her prison, has agreed to visit her
            but has been denied access). <a href="https://www.aafiamovement.com/support-imam" target="_blank" style="color: #0066cc; text-decoration: underline;">https://www.aafiamovement.com/support-imam</a></li>
              <li style="margin-bottom: 15px;">● Experts in all kinds of science can work with Clive to debunk some of the ridiculous
            assertions against her.</li>
              <li style="margin-bottom: 15px;">● Anyone can write stories about her describing her plight</li>
            </ul>
            <br /><br />
            To reach out to Dr Fowzia, contact her Personal Assistant, Farrukh Shah at <a href="https://wa.me/923000901258" target="_blank" style="color: #0066cc; text-decoration: underline;">+923000901258</a> (WhatsApp)
            <br /><br />
            Her U.S. lawyer, Clive A. Stafford Smith, may be contacted via email
            (<a href="mailto:clivestaffordsmith2020@gmail.com" style="color: #0066cc; text-decoration: underline;">clivestaffordsmith2020@gmail.com</a>) or WhatsApp (<a href="https://wa.me/447885649246" target="_blank" style="color: #0066cc; text-decoration: underline;">+44 7885 649246</a>).`,
    };
  },
  methods: {
    highlightText(text, query) {
      if (!text || !query || !query.trim()) {
        return text || '';
      }
      
      const searchQuery = query.trim();
      const escapedQuery = this.escapeRegex(searchQuery);
      const regex = new RegExp(`(${escapedQuery})`, 'gi');
      
      // Handle HTML content - find text nodes and highlight them
      return text.replace(/>([^<]+)</g, (match, textContent) => {
        const highlighted = textContent.replace(regex, '<mark class="search-highlight">$1</mark>');
        return `>${highlighted}<`;
      });
    },
    escapeRegex(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
  },
};
</script>
<style scoped>
.backgrounder-heading {
  text-align: center;
  font-weight: bold;
  font-size: 50px;
  margin-bottom: 24px;
  line-height: 1.2;
}

.backgrounder-subheading {
  text-align: center;
  font-weight: bold;
  font-size: 30px;
  margin-bottom: 24px;
  line-height: 1.3;
}

.backgrounder-content {
  margin-top: 24px;
}

/* Highlight text styling - use :deep() to target spans in v-html */
:deep(.highlight-text) {
  font-weight: bold !important;
  font-size: 1.35em !important;
  display: block;
  color: #2c3e50;
  background-color: #f8f9fa;
  border-left: 5px solid #198754;
  padding: 20px 25px;
  margin-top: 28px;
  margin-bottom: 28px;
  margin-left: 0;
  margin-right: 0;
  border-radius: 6px;
  line-height: 1.7;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
}

/* Link styling */
:deep(a) {
  color: #0066cc !important;
  text-decoration: underline;
}

:deep(a:hover) {
  color: #0052a3 !important;
}

.backgrounder-images {
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
  flex-wrap: wrap;
}

.backgrounder-image {
  max-width: 400px;
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  object-fit: contain;
}

@media screen and (max-width: 991px) {
  .backgrounder-images {
    flex-direction: column;
    gap: 30px;
  }
  
  .backgrounder-image {
    max-width: 350px;
  }
}

@media screen and (max-width: 479px) {
  .backgrounder-image {
    max-width: 100%;
  }
}

/* Search highlight styling */
:deep(.search-highlight) {
  background-color: #198754;
  color: #fff;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(25, 135, 84, 0.3);
  display: inline-block;
}

@media screen and (max-width: 991px) {
  .backgrounder-heading {
    font-size: 36px;
  }
  
  .backgrounder-subheading {
    font-size: 26px;
  }
}

@media screen and (max-width: 479px) {
  .backgrounder-heading {
    font-size: 28px;
  }
  
  .backgrounder-subheading {
    font-size: 22px;
  }
}
</style>

